import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import BlotFormatter from 'quill-blot-formatter';
import classes from './QuillInput.module.css';
Quill.register('modules/blotFormatter', BlotFormatter);

function QuillInput({
  value,
  setter,
  quillClass = '',
  placeholder = '',
  label,
  disabled,
  language, // Add language as a prop
  ...props
}) {
  const toolbarOption = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ['link', 'image'],
    ['clean']
  ];

  const modules = {
    blotFormatter: {
      overlay: {
        style: { border: '2px solid var(--dashboard-main-color)' }
      }
    },
    toolbar: toolbarOption
  };

  // Dynamically set direction based on the language
  const editorDirection = ['ar', 'fa'].includes(language) ? 'rtl' : 'ltr';

  return (
    <>
      {label && <label className={classes.label}>{label}</label>}
      <style>{`
        .ql-disabled {
          background-color: var(--disabled-input-color);
        }
        .ql-snow {
          background-color: ${disabled ? 'var(--disabled-input-color)' : '#E0F3F1'};
        }
        .ql-editor {
          direction: ${editorDirection}; /* Dynamically set the text direction */
          text-align: ${
            editorDirection === 'rtl' ? 'right' : 'left'
          }; /* Align text based on direction */
        }
      `}</style>
      <div className={classes.quillInput}>
        <ReactQuill
          className={`${classes.quill} ${disabled && classes.disabledQuillInput} ${quillClass}`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setter(e)}
          modules={modules}
          readOnly={disabled}
          dir={editorDirection} // Apply RTL or LTR direction
          {...props}
        />
      </div>
    </>
  );
}

export default QuillInput;
